import type { NodeEntry } from 'slate';
import { Editor, Node, Text, Transforms } from 'slate';

import { CHECKBOX_CHECKED, CHECKBOX_UNCHECKED } from '../../../constants';
import type { CheckboxElement } from '../../internal';
import { createDefaultText } from '../../internal';

export function normalizeCheckboxElement(
  editor: Editor,
  checkboxEntry: NodeEntry<CheckboxElement>
): boolean {
  const [, checkboxPath] = checkboxEntry;
  for (const [childNode, childPath] of Node.children(editor, checkboxPath, { reverse: true })) {
    if (!Text.isText(childNode)) {
      Transforms.removeNodes(editor, { at: childPath, voids: true });
      return true;
    }
  }

  return ensureCheckboxStateText(editor, checkboxEntry);
}

function ensureCheckboxStateText(
  editor: Editor,
  checkboxEntry: NodeEntry<CheckboxElement>
): boolean {
  const [, checkboxPath] = checkboxEntry;
  for (const [childNode, childPath] of Node.children(editor, checkboxPath, { reverse: true })) {
    if (childPath.at(-1) === 0) break;
    if (Text.isText(childNode)) {
      Transforms.removeNodes(editor, { at: childPath, voids: true });
      return true;
    }
  }

  const textPath = checkboxPath.concat(0);
  const first = Node.get(editor, textPath);
  const text = Text.isText(first) ? first.text : undefined;
  const expected =
    text === CHECKBOX_CHECKED || text === CHECKBOX_UNCHECKED ? text : CHECKBOX_UNCHECKED;

  if (!Text.isText(first)) {
    Transforms.insertNodes(editor, createDefaultText({}, expected), { at: textPath, voids: true });
    return true;
  }
  if (first.text !== expected) {
    Transforms.insertText(editor, expected, {
      at: Editor.range(editor, textPath),
      voids: true,
    });
    return true;
  }

  return false;
}
